export default function createKeyTransformer(caseConverter) {
  return function keyTransformer(obj) {
    if (Array.isArray(obj)) {
      return obj.map(keyTransformer);
    }

    if (!obj || typeof obj === 'string' || typeof obj === 'number') {
      return obj;
    }

    if (Object.keys(obj).length) {
      return Object.entries(obj).reduce(
        (acc, [key, val]) =>
          Object.assign(acc, {
            [caseConverter(key)]: Array.isArray(val)
              ? val.map(i => keyTransformer(i))
              : typeof val === 'object'
                ? keyTransformer(val)
                : val,
          }),
        {},
      );
    }

    return obj;
  };
}
